module.exports = __webpack_public_path__ + "static/servicing-dd6a71b5c608e5492e503f8de43e955c.png";